
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'FONTAINEANDRUTHERFORD',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/FONTAINEANDRUTHERFORD.vue